export const categories = [
  {
    slug: 'plot',
    name: '剧情介绍',
    description: '深入了解继母的朋友们漫画的完整剧情脉络、故事发展与精彩桥段',
    icon: 'ri-book-open-line',
    image: 'https://readdy.ai/api/search-image?query=Manga%20comic%20book%20opened%20on%20a%20warm%20wooden%20desk%20with%20soft%20ambient%20lighting%2C%20storytelling%20atmosphere%2C%20artistic%20illustration%20pages%20visible%2C%20cozy%20reading%20nook%2C%20warm%20toned%20photography%20with%20shallow%20depth%20of%20field&width=800&height=600&seq=cat-plot-01&orientation=landscape',
    articleCount: 12,
  },
  {
    slug: 'characters',
    name: '角色解析',
    description: '逐一剖析继母的朋友们漫画中的人物性格、关系网络与成长轨迹',
    icon: 'ri-user-heart-line',
    image: 'https://readdy.ai/api/search-image?query=Character%20design%20sketches%20laid%20out%20on%20a%20minimalist%20workspace%20with%20warm%20neutral%20background%2C%20art%20concept%20sheets%2C%20soft%20natural%20light%20from%20window%2C%20creative%20studio%20aesthetic%2C%20editorial%20style&width=800&height=600&seq=cat-char-01&orientation=landscape',
    articleCount: 8,
  },
  {
    slug: 'updates',
    name: '更新资讯',
    description: '第一时间获取继母的朋友们漫画最新话更新、连载状态与相关动态',
    icon: 'ri-timer-flash-line',
    image: 'https://readdy.ai/api/search-image?query=Digital%20tablet%20displaying%20manga%20update%20notification%20on%20a%20clean%20minimal%20desk%2C%20warm%20ambient%20lighting%2C%20modern%20reading%20setup%2C%20cozy%20evening%20atmosphere%2C%20soft%20focus%20background&width=800&height=600&seq=cat-update-01&orientation=landscape',
    articleCount: 6,
  },
  {
    slug: 'reviews',
    name: '评价讨论',
    description: '汇集继母的朋友们漫画读者评价、深度分析及各平台评分讨论',
    icon: 'ri-chat-quote-line',
    image: 'https://readdy.ai/api/search-image?query=Community%20discussion%20and%20review%20atmosphere%20with%20warm%20cafe%20setting%2C%20people%20sharing%20thoughts%20about%20comics%2C%20cozy%20social%20space%2C%20soft%20warm%20lighting%2C%20lifestyle%20photography%20style&width=800&height=600&seq=cat-review-01&orientation=landscape',
    articleCount: 10,
  },
  {
    slug: 'reading',
    name: '在线阅读',
    description: '提供继母的朋友们漫画在线阅读入口引导、平台推荐与阅读指南',
    icon: 'ri-smartphone-line',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20digital%20manga%20reading%20app%20interface%20on%20a%20cozy%20bedside%20table%2C%20warm%20evening%20lighting%2C%20comfortable%20reading%20environment%2C%20modern%20digital%20lifestyle%2C%20soft%20atmospheric%20photography&width=800&height=600&seq=cat-read-01&orientation=landscape',
    articleCount: 5,
  },
];

export const allCategories = categories;